(function() { module.exports = window["Next"]["Notification"]; }());